"use client";

import { MessageCircle, Tag } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PromotionalOffer() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="promotionaloffer" className="bg-primary py-20 lg:py-32 overflow-hidden relative z-0">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-6 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <Badge variant="outline" className="bg-background/50 backdrop-blur-sm border-primary/20 text-primary px-4 py-1.5 rounded-full text-sm font-medium">
              <Tag className="w-4 h-4 mr-2" />
              Promozione Esclusiva
            </Badge>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-primary-foreground leading-[1.1]">
              Scarica il coupon da <span className="text-white">100 Euro</span>
            </h2>

            <p className="text-lg md:text-xl text-primary-foreground/90 max-w-xl leading-relaxed font-normal">
              Rinnova i tuoi ambienti con LORA SERRAMENTI. Richiedi subito il tuo coupon e ottieni uno sconto immediato su una spesa minima di 1000 euro. Sicurezza, comfort e design a un prezzo speciale.
            </p>

            <div className="pt-4">
              <Button asChild size="lg" className="bg-chart-2 text-white hover:bg-chart-2/90 rounded-full h-14 px-8 text-base shadow-lg shadow-chart-2/20 hover:shadow-xl hover:shadow-chart-2/30 transition-all duration-300 border-none">
                <Link to="https://wa.me/393349255303?text=Buongiorno%2C%20vorrei%20richiedere%20il%20coupon%20da%20100%E2%82%AC%20(su%20spesa%20minima%20di%201000%E2%82%AC)" newTab>
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Richiedi su WhatsApp
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-border/50 bg-background">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/premium_offer_ticket_coupon.png" alt="Coupon Promozionale 100 Euro Lora Serramenti" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700 ease-in-out" />
                {}
                <div className="absolute inset-0 bg-gradient-to-tr from-black/10 to-transparent pointer-events-none" />
              </AspectRatio>
            </div>

            {}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-primary/5 rounded-full blur-3xl pointer-events-none" />
          </div>
        </div>
      </div>
    </section>;
}